@if (storeMap) {
  <div fxLayout="column" fxFlexFill>
    <bt-map [map]="storeMap" size="medium" zoom="fill" [pan]="true" (load)="onMapLoad($event)" [canvasOptions]="canvasOptions"></bt-map>
  </div>
}
